import { useEffect} from "react";



const useBonanza5 = (dispatch, totalData) => {
    console.log('useBonanza5')
    const target = "bonanza5"
    const parameters = {game_id: 218, take: totalData, sub_name: "" }

    useEffect(() => {
        const getBonanza5Data = async () => {
            console.log('getBonanza5Data')
            dispatch({type: "setLoading", payload: {target: target, loading: true}})
            dispatch({type: "setData", payload: {target: target, data: null}})
            const url = "https://trapi.easywin.ng/api/V2/LottoDrawResult/bonanza5";

            try {
                const response = await fetch(url, {
                    headers: {
                        "Content-Type": "application/json"
                    },
                    method: "POST",
                    body: JSON.stringify(parameters)
                })
                if (response.ok) {
                    const json = await response.json()
                    if (json.status === true) {
                        dispatch({type: "setData", payload: {target: target, data: json.data.list}})
                        dispatch({type: "setError", payload: {target: target, error: null}})
                    }
                } else {
                    throw new Error("Request error")
                }             
            } catch (error) {
                console.log(error)
                dispatch({type: "setError", payload: {target: target, error: error}})
                dispatch({type: "setData", payload: {target: target, data: null}})
            }
            dispatch({type: "setLoading", payload: {target: target, loading: false}})      
        }

        getBonanza5Data()
        
    }, [])

    return null
}


export default useBonanza5;